import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function WeddingCargo() {
  return (
    <div className="dashboard-section">
      <h1>
        Wedding Cargo
        <InfoButton
          title="Wedding Cargo"
          content={
            <div>
              <p>
                List of things to buy / bring. Use the Packlist sheet for all the little things: 
                chargers, signage, safety pins. Future you will be grateful.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Create custom packing lists</li>
                <li>Checkbox + progress tracking</li>
                <li>Organize by category or timeline</li>
                <li>Add items to buy or bring</li>
                <li>Share with wedding party or helpers</li>
              </ul>
              <p>
                Pack it like a pro — nothing forgotten, everything organized.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={3} />
    </div>
  )
}

export default WeddingCargo
